/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';
import { Button } from 'react-bootstrap';

import { connect } from 'react-redux';
import store from 'features/store';

import { PayPalHostedField, PayPalHostedFieldsProvider, PayPalScriptProvider } from "@paypal/react-paypal-js";
// project imports
import { createOrder, generateClientToken } from "shared/services/PaypalServices";
import { AddCard } from '../../auth-pages/MyAccount/payment-methods/PaymentMethodsAdd';
import { PAYPAL_SANDBOX, PayPalClientId } from 'shared/settings/config';
import { CityAndStateService } from 'shared/services';
import { ArrayValueReorder } from 'shared/modifiers';

import './PaypalSDK.scss';

class PaypalSDK extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: true
        };

        this.paypalSdkOptions = {
            'client-id': PayPalClientId,
            'data-client-token': '',
            components: 'hosted-fields',
            intent: 'authorize',
            vault: true
        };

        this.paypalClientMetadataId = new Array(32).join().replace(/(.|$)/g, () => ((Math.random() * 36) | 0).toString(36));
    }

    async componentDidMount() {
        store.dispatch({ type: 'SET_HEADER', payload: false });
        store.dispatch({ type: 'SET_COVID_BANNER', payload: false });

        this.paypalSdkOptions['data-client-token'] = await generateClientToken(this.props.match.params.buyerId);

        await CityAndStateService.getStateList().then(res => {
            this.setState({ stateList: ArrayValueReorder(res.data.data, 'state'), pageLoading: false });
        }).catch(() => this.setState({ pageLoading: false }));

        /* add fraudnet script tags */
        setTimeout(() => {
            const fradunetParams = document.createElement('script');
            fradunetParams.id = 'fradunetParams';
            fradunetParams.type = 'application/json';
            fradunetParams.setAttribute('fncls', 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99'); // constant value do not change for any env
            fradunetParams.innerHTML = JSON.stringify({
                f: this.paypalClientMetadataId,
                s: 'CTBIDS_WFX7W3JDWDDKU_FI', // constant value do not change for any env
                sandbox: PAYPAL_SANDBOX

            });
            document.body.appendChild(fradunetParams);

            const fraudnetScript = document.createElement('script');
            fraudnetScript.id = 'fraudnetScript';
            fraudnetScript.type = 'text/javascript';
            fraudnetScript.async = true;
            fraudnetScript.src = 'https://c.paypal.com/da/r/fb.js'; // do not change for any env
            document.body.appendChild(fraudnetScript);
        }, 3000);
    }

    render() {
        return (
            <div className="paypal-sdk-container">
                {
                    this.state.pageLoading ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> : 
                        <PayPalScriptProvider options={this.paypalSdkOptions}>
                            <PayPalHostedFieldsProvider createOrder={() => createOrder(this.paypalClientMetadataId)}
                                styles={{ ".valid": { "color": "#28a745" }, ".invalid": { "color": "#dc3545" } }}>

                                <div>
                                    <label className="m-0"><b>Card Number<sup className="text-danger">*</sup></b></label>
                                    <PayPalHostedField id="card-number" className="card-field" hostedFieldType="number"
                                        options={{ selector: "#card-number", placeholder: 'XXXX-XXXX-XXXX-XXXX' }} />
                                </div>

                                <div className="d-flex flex-column flex-sm-row justify-content-between" style={{ gap: '10%' }}>
                                    <div>
                                        <label className="m-0"><b>Expiration Date<sup className="text-danger">*</sup></b></label>
                                        <PayPalHostedField id="expiration-date" className="card-field" hostedFieldType="expirationDate"
                                            options={{ selector: "#expiration-date", placeholder: "MM/YYYY" }} />
                                    </div>

                                    <div>
                                        <label className="m-0"><b>CCV<sup className="text-danger">*</sup></b></label>
                                        <PayPalHostedField id="cvv" className="card-field" hostedFieldType="cvv"
                                            options={{ selector: "#cvv", placeholder: '***', maskInput: true }} />
                                    </div>
                                </div>

                                <AddCard {...this.props} termsModalOpen={() => this.setState({ termsModalShow: true })}
                                    stateList={this.state.stateList} paypalClientMetadataId={this.paypalClientMetadataId} platform='mobile' />
                            </PayPalHostedFieldsProvider>
                        </PayPalScriptProvider>
                }
            </div>
        );
    }
}

export default connect(state => state)(PaypalSDK);